import { apiClient, type TruckModelEntity } from '@/libs/api'
import type { TruckModelsRequestQuery } from '@/libs/api/types'

export type FetchTruckModelsQuery = {
  tenantKey: string
  query?: TruckModelsRequestQuery
}

export type FetchPackageCategoriesResponse = {
  data: TruckModelEntity[]
}

/**
 * 車種一覧を取得（ページングなし）
 */
export const fetchTruckModels = async (
  { tenantKey, query }: FetchTruckModelsQuery,
  signal?: AbortSignal
): Promise<FetchPackageCategoriesResponse> => {
  const { data } = await apiClient._tenant(tenantKey).truck_models.$get({
    query,
    config: {
      signal
    }
  })
  return { data }
}
